import { Spinner } from '@/components/ui/Spinner';

export function BootLoader() {
  return (
    <div
      role="status"
      aria-label="Loading"
      className="flex flex-1 items-center justify-center"
    >
      <Spinner size="lg" className="text-primary" aria-hidden />
    </div>
  );
}
